/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { signInActions } from 'modules/sign-in/slice';
/**
 * Define the the Event category configuration feature initial state
 */
export const initialState = {
  loading: false,
  eventCategories: [],
  minorEventCategories: [],
  updatedMinorEvent: false,
  hotelId: null,
};
/**
 * All the event category configuration feature related actions are defined here
 */
export const configureEventCategoriesSlice = createSlice({
  name: SLICE.CONFIGURE_EVENT_CATEGORIES,
  initialState,
  reducers: {
    configureEventCategories(state) {
      state.loading = true;
    },
    configureEventCategoriesSucceeded(state, action) {
      state.loading = false;
      state.eventCategories = action?.payload;
    },
    configureEventCategoriesFailed(state) {
      state.loading = false;
    },
    addMinorEventCategories(state) {
      state.loading = true;
      state.updatedMinorEvent = false;
    },
    addMinorEventCategoriesSucceeded(state) {
      state.loading = false;
      state.updatedMinorEvent = true;
    },
    addMinorEventCategoriesFailed(state) {
      state.loading = false;
    },
    getMinorEventCategories(state) {
      state.loading = true;
    },
    getMinorEventCategoriesSucceeded(state, action) {
      state.loading = false;
      state.minorEventCategories = action?.payload;
    },
    getMinorEventCategoriesFailed(state) {
      state.loading = false;
    },
    updateMinorEventCategories(state) {
      state.loading = true;
      state.updatedMinorEvent = false;
    },
    updateMinorEventCategoriesSucceeded(state) {
      state.loading = false;
      state.updatedMinorEvent = true;
    },
    updateMinorEventCategoriesFailed(state) {
      state.loading = false;
    },
    deleteMinorEventCategories(state) {
      state.loading = true;
      state.updatedMinorEvent = false;
    },
    deleteMinorEventCategoriesSucceeded(state) {
      state.loading = false;
      state.updatedMinorEvent = true;
    },
    deleteMinorEventCategoriesFailed(state) {
      state.loading = false;
    },
    setHotelId(state, action) {
      state.hotelId = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: configureEventCategoriesActions } = configureEventCategoriesSlice;
